import React from 'react'
import { ROOT_NODE, useEditor } from '@craftjs/core'
import { isDisabled } from '../../../../utils/node'
import { Click } from '../../../../pb-components/icons'

export const Toolbar = () => {
  const { selected, related, query } = useEditor((state) => ({
    selected: state.events.selected,
    related: state.events.selected && state.nodes[state.events.selected].related,
  }))

  return (
    <>
      {selected && selected !== ROOT_NODE && !isDisabled(selected, query) && related.toolbar ? (
        React.createElement(related.toolbar)
      ) : (
        <div className="empty-message">
          <p>Click on a component to start editing.</p>
          <Click />
        </div>
      )}
    </>
  )
}
